<div class="flex justify-end items-center box-border" *ngrxLet="columnNotes$; let columnNotes">

  <button mat-icon-button
          class="text-neutral-variant-40 iconButtonReducedDensity mx-1"
          (click)="sizeColumnsToFit($event)"
          matTooltip="Adjust visible columns in size to fit available horizontal space">
    <mat-icon svgIcon="resize_columns"></mat-icon>
  </button>

  <button mat-icon-button
          class="text-neutral-variant-40 iconButtonReducedDensity mx-1"
          (click)="resetTableLayout($event)"
          matTooltip="Restore default column settings"
          appGtagEvent
          trackOn="click"
          action="Apply default columns"
          category="Adapt column display [overhaul]"
          [params]="{event_label: 'Apply default columns'}">
    <mat-icon svgIcon="reset_columns"></mat-icon>
  </button>

  <mat-divider vertical
               class="ml-2 mr-4 h-[22px]"></mat-divider>

  <button [ngClass]="{
        columnNotesInfoToggle: true,
        infoMenuOpened: columnNotesInfoOpened
      }"
    [matMenuTriggerFor]="columnNotesInfo"
    #menuTrigger="matMenuTrigger"
    mat-icon-button
    (click)="columnNotesInfoOpened=true">
      <mat-icon svgIcon="sticky_note_info"
                id="menuTriggerIcon"></mat-icon>
  </button>

  <!-- Column notes info menu -->
  <mat-menu class="columnNotesInfo"
    #columnNotesInfo="matMenu"
    xPosition="before"
    yPosition="below"
    (close)="columnNotesInfoOpened=false">

    <ng-template matMenuContent>
      <div class="flex flex-row pb-1">
        <p class="columnNoteMenuHeader w-full">Column notes</p>
      </div>

      @if (columnNotes?.length) {
        @for (columnNote of columnNotes; track columnNote) {
          <div
            class="flex flex-row">
            <mat-icon svgIcon="sticky_note_with_content"
              [class]="columnNote.noteColor"
            class="columnNoteIcon flex"></mat-icon>
            <div class="pl-2 pb-4 flex flex-col w-full">
              <div class="flex flex-row w-full">
                <p class="columnNoteName flex-grow">{{ getPrettyFieldName(
                columnNote.columnName) }}</p>
                <p class="columnNoteTimeLabel">{{getTimeFromNow(
                  columnNote.noteUpdateTime ? columnNote.noteUpdateTime
                : columnNote.noteCreateTime)}}</p>
              </div>
              <p class="columnNoteText"
              [innerHTML]="(columnNote.noteText | extractAndWrapLinks)"></p>
            </div>
          </div>
        }
      }

      @if (!columnNotes?.length) {
        <p class="columnNoteText">Nothing to see here...</p>
      }

    </ng-template>
  </mat-menu>
</div>


